//setting filter panel visibility
export const setisFilterPanelVisible = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_PANEL_VISIBLE", payload: value });
  };
};

//setting filter data to show all the attributes in filter panel
export const setFilterPanelData = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_DATA", payload: value });
  };
};

//setting filter active key when collapse is clicked
export const setFilterActiveKey = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_ACTIVE_KEY", payload: value });
  };
};

export const setFilterDateActiveKey = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_DATE_ACTIVE_KEY", payload: value });
  };
};

export const setFilterDate = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_DATE", payload: value });
  };
};

export const setFilterApply = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_APPLY", payload: value });
  };
};

export const setFilterApplied = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_APPLIED", payload: value });
  };
};

export const setradioArray = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_RADIO_ARRAY", payload: value });
  };
};

export const setradioChecked = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_RADIO_CHECKED", payload: value });
  };
};

export const setFilterChange = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_CHANGE", payload: value });
  };
};
export const setChecked = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_CHECKED", payload: value });
  };
};
export const setCheckedArray = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_CHECKED_ARRAY", payload: value });
  };
};
export const setIsWidgetEdit = (value) => {
  return (dispatch) => {
    dispatch({ type: "IS_WIDGET_EDIT", payload: value });
  };
};

export const setRemoveWordsPanelFlag = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_REMOVE_WORDS_PANEL_FLAG", payload: value });
  };
};
export const setBubbleRef = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_BUBBLECHART_REF", payload: value });
  };
};

export const setWidgetClearFilter = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_WIDGET_CLEAR_FILTER", payload: value });
  };
};
